// extracted by mini-css-extract-plugin
export var drawerPaper = "_1b-0";
export var itemImage = "_1b-1";